// extracted by mini-css-extract-plugin
module.exports = {"mapWrapperDesk":"mapRender_mapWrapperDesk__bodxu","mapWrapperMobile":"mapRender_mapWrapperMobile__3PvXm","base":"mapRender_base__2dDDx","selected":"mapRender_selected__1_4-0"};